// extracted by mini-css-extract-plugin
export default {"sourceName":"SourceName_sourceName__7ot8B"};